import Image from "next/image";
import { useMemo } from "react";
import { m, MotionConfig } from "framer-motion";
import GradientCircle from "./Gradient";

export default function Project({ project, index }) {
  const { image, title, description } = project;

  // small neutral SVG used as a lightweight blur placeholder
  const blurDataURL = useMemo(() => {
    const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><rect width='100%' height='100%' fill='%23F0F0F0'/></svg>`;
    return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  }, []);

  const isEven = index % 2 === 0;

  const imageVariants = {
    hidden: { x: isEven ? -200 : 200, opacity: 0 },
    visible: { x: 0, opacity: 1 },
  };

  const textVariants = {
    hidden: { y: 100, opacity: 0 },
    visible: { y: 0, opacity: 1 },
  };

  return (
    <MotionConfig reducedMotion="user">
      <m.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
        className={`flex flex-col items-center justify-center mobile2:items-stretch mobile2:flex-row gap-8 lg:gap-16 mb-10 lg:mb-14 ${isEven ? "" : "mobile2:flex-row-reverse"}`}
      >
        <div className="relative flex h-auto items-center justify-center  tablet:w-75 tablet:h-72 xl:w-95 xl:h-90 laptop:w-[450px]  laptop:h-[360px] ">
          <m.div
            variants={imageVariants}
            transition={{ duration: 0.3, type: "linear" }}
            className="relative flex aspect-3/2 w-50 mobile2:w-45 sm:w-53 md:w-63 tablet:w-75 lg:w-84 xl:w-[430px] laptop:w-[452px] mx-auto mobile2:shrink-0"
          >
            <Image
              src={image}
              alt={title}
              fill
              className="object-contain mobile2:mt-5 tablet:mt-10"
              quality={75}
              loading="lazy"
              placeholder="blur"
              blurDataURL={blurDataURL}
            />
          </m.div>

          <GradientCircle />
        </div>

        <m.div
          variants={textVariants}
          transition={{ duration: 0.3, type: "linear" }}
          className="flex flex-col mobile2:mt-5 tablet:mt-10 will-change-transform transform-gpu"
        >
          <h1 className="text-center mobile2:text-left font-alexandria font-semibold text-[22px] sm:text-[24px] md:text-[28px] lg:text-[32px] xl:text-[35px] 3xl:text-[40px] 4xl:text-[42px] uppercase">
            {title}
          </h1>
          <p className="text-center mobile2:text-left font-manrope font-normal text-[14px] md:text-[16px] lg:text-[18px] xl:text-xl 3xl:text-[22px] 4xl:text-[24px] mt-4 dark:text-[#7F7F7F] text-[#5A5A6E] leading-tight md:leading-[30px] tracking-[0.02em]">
            {description}
          </p>
        </m.div>
      </m.div>
    </MotionConfig>
  );
}
